import type { UploadResult } from '../types/file-upload';

/**
 * 第一阶段：文件上传服务接口
 */
export interface FileUploadService {
    /**
     * 上传文件到服务器
     * @param params 上传参数
     * @param params.file 要上传的文件
     * @param params.contentType 文件内容类型
     * @param onProgress 进度回调函数
     * @returns 上传结果
     */
    upload(params: { file: File; contentType: 'DISCLOSURE' | 'CLAIM' }, onProgress?: (progress: number) => void): Promise<UploadResult>;
}

/**
 * 文件上传服务绑定标识
 */
export const FileUploadService = Symbol.for('FileUploadService');
